<template>
  <div class="summary-payment">
    <h2 class="h3"><slot name="headline"></slot></h2>
    <ul class="list-unstyled">
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblIban"></slot>
          </div>
          <div>{{ paymentData.iban }}</div>
        </div>
      </li>
      <li>
        <div class="row">
          <div class="label">
            <slot name="lblAccountOwner"></slot>
          </div>
          <div>{{ paymentData.accountHolder }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  name: 'Payment',
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  computed: {
    paymentData () {
      return this.$store.getters['checkoutv2/' + this.process + '/_paymentData/bankAccount']
    }
  }
}
</script>
